const constants = {
  CREATE_NEW_GAZETTEER: 'createNewGazetteer',
  CREATE_FROM_EXISTING: 'createFromExisting',
  FEATURE_ADD: 'featureAdd',
  FEATURE_ACTIVE: 'featureActive',
  FEATURE_DELETE: 'featureDelete',
  FEATURE_UPDATE_INDEX: 'featureUpdateIndex',
  HOME: 'home',
  SET_NAME: 'setName',
  SET_PLACE_NAME: 'setPlaceName',
  SET_PLACE_DESCRIPTION: 'setPlaceDescription',
  SET_POSITION: 'setPosition',
  SET_META: 'setMeta',
  SET_TAGS: 'setTags',
  SET_MAP_RESULT: 'setMapResult'
};

module.exports = constants;
